import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { Divider } from "./Ornaments";
import { NAV, WHATSAPP_NUMBERS, EMAIL, INSTAGRAM_URL, whatsappLink } from "@/data/content";
import { scrollToId } from "./Reveal";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-blush pt-20 pb-28 sm:pb-12">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="text-center">
        <p className="font-display text-4xl sm:text-6xl lg:text-7xl text-ink leading-[1.05]">Every Occasion.<br /><span className="italic text-terra">Extraordinary Experiences.</span></p>
        <Divider />
      </div>
      <div className="mt-14 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <Logo className="h-20" onClick={(e) => { e.preventDefault(); scrollToId("top"); }} />
          <p className="text-sm text-muted-ink mt-4 max-w-xs">A modern Indian celebrations studio for weddings, family milestones, corporate events and spiritual gatherings.</p>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-3 md:justify-center">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} data-testid={`footer-link-${n.id}`} onClick={(e) => { e.preventDefault(); scrollToId(n.id); }} className="nav-link text-sm text-ink/85">{n.label}</a>
          ))}
        </nav>
        <div className="md:text-right flex flex-col md:items-end gap-2.5">
          <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="btn-sage"><MessageCircle size={16} /> {WHATSAPP_NUMBERS[0].disp}</a>
          <a href={`tel:+${WHATSAPP_NUMBERS[1].num}`} data-testid="footer-phone-2" className="inline-flex items-center gap-2 text-sm text-ink hover:text-terra-deep transition-colors"><Phone size={14} /> {WHATSAPP_NUMBERS[1].disp}</a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="inline-flex items-center gap-2 text-sm text-ink hover:text-terra-deep transition-colors"><Mail size={14} /> {EMAIL}</a>
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="btn-ghost mt-1"><Instagram size={16} /> @nexoraevents.in</a>
        </div>
      </div>
      <p className="mt-14 pt-6 border-t border-terra/15 text-xs text-muted-ink text-center">© 2026 Nexora Events. Made with love in India.</p>
    </div>
  </footer>
);
